import { getContext, setContext } from "svelte";
export const socket = io("https://apiildaa.herokuapp.com");
export const sauvegarde = (joueur) => {

    socket.emit("sauvegarde", joueur);


}
// setContext("socket", socket);